import React, { useState } from "react";
import { PageHeader, Panel, Table, Pager, useAdminQuery, RefreshButton, Unavailable, StatusChip, fmtDate, INK, MUTE, BORDER } from "../_shared";

export default function AdminUsers() {
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const r = useAdminQuery("/admin/users", { page, page_size: 25, q: search || undefined, status: status || undefined });

  return (
    <div data-testid="admin-users-page">
      <PageHeader title="Users"
        subtitle="Read-only directory of registered users."
        right={<RefreshButton loading={r.loading} onClick={r.refresh} />} />
      <Panel>
        <form onSubmit={(e) => { e.preventDefault(); setSearch(q); setPage(1); }}
              style={{ display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
          <input value={q} onChange={(e) => setQ(e.target.value)}
                 placeholder="Search name, email or user_id"
                 data-testid="admin-users-search"
                 style={inputStyle} />
          <select value={status} onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                   data-testid="admin-users-status"
                   style={inputStyle}>
            <option value="">All</option>
            <option value="onboarded">Onboarded</option>
            <option value="incomplete">Incomplete</option>
          </select>
          <button type="submit" style={{ padding: "8px 16px", borderRadius: 999,
            background: INK, color: "white", border: 0, cursor: "pointer", fontSize: 12.5 }}>
            Search
          </button>
        </form>

        {r.loading ? <Loading /> : r.error ? <Unavailable error={r.error} /> : (
          <>
            <Table cols={[
              { label: "Name",     render: (u) => u.name || "—" },
              { label: "Email",    render: (u) => u.email || "—" },
              { label: "Joined",   render: (u) => fmtDate(u.created_at) },
              { label: "Last active", render: (u) => fmtDate(u.last_active_at) },
              { label: "Balance",  render: (u) => (u.balance ?? 0).toLocaleString() },
              { label: "Onboarded", render: (u) => <StatusChip status={u.onboarded ? "YES" : "NO"} /> },
              { label: "Report",   render: (u) => u.has_life_report ? "✓" : "—" },
            ]} rows={r.data?.rows || []} keyFn={(x) => x.user_id} testId="admin-users-table" />
            <Pager page={page} pageSize={25} total={r.data?.total || 0} onPage={setPage} />
          </>
        )}
      </Panel>
    </div>
  );
}

const inputStyle = {
  flex: 1, minWidth: 220, padding: "8px 12px",
  borderRadius: 10, border: `1px solid ${BORDER}`,
  background: "white", color: INK, fontSize: 13,
};
function Loading() { return <div style={{ padding: 30, color: MUTE, fontSize: 13, textAlign: "center" }}>Loading…</div>; }
